<template>
  <div class="wrapper">
    <page :is_need_tab_nav="true">
      <div class="flex-box flex-a-center mb24">
        <h1 class="pointer" :class="{fs24:unread == 0,fs16:unread == 1,'black-3':unread == 1}" @click="tab(0)">{{$t('Message.text1')}}</h1>
        <h1 class="ml16 pointer" :class="{fs24:unread == 1,fs16:unread == 0,'black-3':unread == 0}" @click="tab(1)">{{$t('Message.text2')}}</h1>
      </div>
      <div class="nav-box-wrapper flex-box" :class="[browser_size != 'small' ? 'flex-direction-column' : '']">
        <router-link to="/notice/comment" class="nav-box flex-box flex-align-items-center flex-justify-content-space-between">
          <div class="flex-box flex-align-items-center">
            <i class="afd afd-comment"></i>
            <span class="black-8 ml-16-8 mq fs-16-14">
              {{$t('Message.text3')}}
            </span>
          </div>
          <span class="num-tip pr12" v-if="unread_count.comment > 0">{{unread_count.comment}}</span>
          <i v-else class="afd afd-arrow-right"></i>
        </router-link>
        <router-link to="/notice/like" class="nav-box like flex-box flex-align-items-center flex-justify-content-space-between ml-0-16 mq">
          <div class="flex-box flex-align-items-center">
            <i class="afd afd-heart"></i>
            <span class="black-8 ml-16-8 mq fs-16-14">
              {{$t('Message.text4')}}
            </span>
          </div>
          <span class="num-tip pr12" v-if="unread_count.like > 0">{{unread_count.like}}</span>
          <i v-else class="afd afd-arrow-right"></i>
        </router-link>
      </div>
      <div class="black-3 mt-32-24 mq" v-if="has_load && dialogs.length == 0">
         <template v-if="unread == 0">
          {{$t('Message.text5')}}
            <router-link class="underline gl-hover-text-purple" to="/my/dashboard">「管理面板」</router-link>查看你赞助的人或是赞助你的人，发起私信。
        </template>
        <template v-if="unread == 1">
          {{$t('Message.text6')}}
        </template>
      </div>
      <div>
        <!-- <router-link
          v-for="dialog in dialogs"
          :key="dialog.id"
          :to="`/message/${dialog.user.user_id}?is_keyboard_up=1`"
        >-->
        <!-- @click.native="jump(`/message/${dialog.user.user_id}?is_keyboard_up=1`)" -->

        <avatar-message
          class="nocopy"
          v-for="(dialog, index) in dialogs"
          :key="index"
          :dialog="dialog"
          :href="`/message/${dialog.user.user_id}?is_keyboard_up=1`"
          v-hammer:press="(event)=> press(dialog.user.user_id)"
          @click.native="jump(`/message/${dialog.user.user_id}?is_keyboard_up=1`, index)"
        ></avatar-message>
        <!-- </router-link> -->
      </div>
      <div class="relative mt24" v-if="is_loading">
        <div class="loading-box">
          <img
            style="width: 50px;margin-left: -25px;"
            src="/static/img/asset/loding.png"
            class="loading self-center-loading"
          />
        </div>
      </div>
    </page>
  </div>
</template>

<script>
import {
  GET_MESSAGE_DELETE_DIALOG,
} from '@/api/config';
import { mapState } from 'vuex';
export default {
  metaInfo() {
    return {
      title: '我的私信 | 爱发电'
    };
  },
  data() {
    return {
      has_load: false,
      is_loading: false,
      page: 1,
      unread: localStorage.getItem('msg_unread_type') || 0,
    };
  },
  watch: {
    unread_message_num() {
      this.get_list();

    //   this.$store.dispatch('message/get:dialogs', { page: this.page, unread: this.unread });
    }
  },
  computed: {
    ...mapState('app', ['session_user', 'unread_message_num', 'unread_count']),
    ...mapState('message', ['dialogs', 'has_more'])
  },
  created() {},
  async beforeMount() {
    this.is_loading = true;
    await this.get_list();
    // await this.$store.dispatch('message/get:dialogs',{ page: this.page, unread: this.unread });
    this.is_loading = false;
    this.page++;
  },
  async mounted() {
    this.$bus.$on('GET_MESSAGE_DIALOGS', data => {
      if (data.status == 'success') {
        this.has_load = true;
      }
    });
    this.$bus.$on('SCROLL_LOAD_MORE_FEED', () => {
      this.load_more();
    });
  },
  beforeDestroy() {
    this.$bus.$off('GET_MESSAGE_DIALOGS');
    this.$bus.$off('SCROLL_LOAD_MORE_FEED');
    this.$store.dispatch('message/reset:dialogs');
  },
  methods: {
    jump(path, msg_index) {
      this.$store.dispatch('message/remove:dialog_unread', msg_index);
      this.$mixin_router_push(path, true);
    },
    async get_list(){
        await this.$store.dispatch('message/get:dialogs', { page: this.page, unread: this.unread });
    },
    async load_more() {
      if (this.has_more == 1 && !this.is_loading) {
        this.is_loading = true;
        await this.get_list();
        // await this.$store.dispatch('message/get:dialogs', { page: this.page, unread: this.unread });
        this.is_loading = false;
        this.page++;
      }
    },
    async press(user_id){
      let re = await this.$mixin_confirm({title:'是否把该私信从列表删除？（不会删除聊天记录）'})
      if(re){
        if(this.$http.is_run(GET_MESSAGE_DELETE_DIALOG)){
            return false
        }
        let data = await this.$http.$axios(GET_MESSAGE_DELETE_DIALOG , { user_id })
        if(data.ec != 200){
          this.$notify({
            title: data.em,
            group:'error',
          })
          return false;
        }
        this.$store.dispatch('message/remove:dialog', user_id);
      }
    },
    async tab(unread){
      if(this.unread != unread){
        localStorage.setItem('msg_unread_type', unread)
        this.page = 1;
        this.unread = unread;
        this.is_loading = true;
        await this.get_list();
        this.is_loading = false;
        this.page++;
      }

    }
  }
};
</script>

<style lang="stylus" scoped>
.wrapper{
  .vm-page /deep/{
    .page-box{
        min-height:35vh;
    }
    .page-content-w100{
        background: $white;
    }
  }
  .vm-avatar-message {
    padding: px2rem(16);
    margin: 0 _px2rem(16);

    &:hover {
      background-color: $black-03;
    }
  }

  .nav-box-wrapper{
    position: fixed;
    left: 50%;
    margin-left: 260px;
  }
  .nav-box {
    width: 240px;
    box-sizing: border-box;
    padding:13px 20px;
    // position: fixed;
    // left: 50%;
    border: 1px solid $grey;
    border-radius: 4px;

    &.like{
      // top:240px;
      margin-top:12px;
    }

    &:hover {
      cursor: pointer;
      background: $white;
    }
  }

  .num-tip {
    // position: relative;
    // color: $red;
    color:$white;
    font-size: 12px;
    padding:1px 7px;
    background: #03D3EE;
    border-radius: 100px;
  }

  @media (max-width: $width-mobile) {
    .nav-box-wrapper{
      position: relative;
      left: 0;
      margin-left: 0;
    }
    .nav-box {
      width: 100%;
      padding:13px 8px 13px 16px;
      background: $white;
      border: 1px solid $grey;
      border-radius: 4px;
      margin-bottom: 16px;
      &.like{
        margin-top:0;
      }
    }
  }
}
</style>
